import { NgModule, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID } from '@angular/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import { ScLayoutTopnavigationComponent } from './layouts/sc-layout-topnavigation/sc-layout-topnavigation.component';
import { AgmCoreModule } from '@agm/core';
import { HumanizedDatePipe } from './pipes/humanized-date.pipe';
import { HumanizedTimeSpanPipe } from './pipes/humanized-time-span.pipe';
import { HumanizedFileSizePipe } from './pipes/humanized-file-size.pipe';
import { ErrorComponent } from './components/error/error.component';
import { NotFoundComponent } from './views/not-found/not-found.component';
import { ScUiModule, ApiConfig } from '@sc-ui';
import { JobComponent } from './views/job/job.component';
import { HeaderComponent } from './components/header/header.component';
import { SalarygraphComponent } from './components/salarygraph/salarygraph.component';
import { IconlistComponent } from './components/iconlist/iconlist.component';
import { MapComponent } from './components/map/map.component';
import { VideoComponent } from './components/video/video.component';
import { FooterComponent } from './components/footer/footer.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { ScLogoComponent } from './components/sc-logo/sc-logo.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { UnsubscribeComponent } from './components/unsubscribe/unsubscribe.component';

import { CollapsibleListComponent } from './components/collapsible-list/collapsible-list.component';

import { TabnavComponent } from './components/tabnav/tabnav.component';
import { TextToHTMLPipe } from './pipes/text-to-html.pipe';

import localeDE from '@angular/common/locales/de';
registerLocaleData(localeDE);

import { SafePipe } from './pipes/safe.pipe';
import { LocalizePipe } from './pipes/localize.pipe';

import { environment } from './environment.prod';
import { ScChatbotModule } from '@sc-ui-chatbot';

import { ActivityItemProjectJobsiteWorkItemCommentedComponent } from './components/activity-item/activity-item-project-jobsite-work-item-commented/activity-item-project-jobsite-work-item-commented.component';
import { ActivityItemComponent } from './components/activity-item/activity-item.component';
import { NgbDropdownModule, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  declarations: [
    AppComponent,
    ScLayoutTopnavigationComponent,
    HumanizedDatePipe,
    HumanizedTimeSpanPipe,
    HumanizedFileSizePipe,
    ErrorComponent,
    NotFoundComponent,
    JobComponent,
    HeaderComponent,
    SalarygraphComponent,
    IconlistComponent,
    MapComponent,
    VideoComponent,
    FooterComponent,
    NavbarComponent,
    ScLogoComponent,
    TopbarComponent,
    UnsubscribeComponent,
    CollapsibleListComponent,
    TabnavComponent,
    TextToHTMLPipe,
    LocalizePipe,
    SafePipe,
    ActivityItemComponent,
    ActivityItemProjectJobsiteWorkItemCommentedComponent
  ],
  imports: [
    HttpClientModule,
    AppRoutingModule,
    CommonModule,
    AgmCoreModule.forRoot({ apiKey: 'AIzaSyBajkLHFeKGPwkvXBqq_GUb9CWv_nyar6g', libraries: ["places"], language: 'de' }),
    ScUiModule,
    ScChatbotModule,
    NgbDropdownModule
  ],
  entryComponents: [],
  providers: [
    {
      provide: LOCALE_ID, useValue: 'de_DE'
    },
    {
      provide: NgbModalConfig,
      useValue: {
        animation: true,
        centered: true
      }
    },
    {
      provide: ApiConfig,
      useValue:
      {
        host: environment.api
      }
    }
  ],
  bootstrap: [AppComponent],
  exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
  constructor() {

  }
}
